import React, { ReactNode, Ref, forwardRef } from 'react'

import { Listbox } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

export interface IButton {
  className?: string
  children?: ReactNode
  disabled?: boolean
  onClick?: () => void
  ref?: Ref<HTMLButtonElement>
  as?: React.ElementType | undefined
}

const Button = forwardRef<HTMLButtonElement, IButton>(
  ({ children, className, onClick, as, disabled = false }, ref) => {
    return (
      <Listbox.Button
        as={as}
        ref={ref}
        onClick={onClick}
        className={twMerge(
          'flex items-center justify-between block w-full rounded-md border-0 py-2 pl-3 pr-2 text-primary-900 dark:text-primary-300',
          'sm:text-sm sm:leading-6 ring-1 ring-inset ring-primary-200 hover:ring-primary-300 focus:outline-none focus:ring-primary-400',
          'dark:ring-primary-700 dark:hover:ring-primary-600 dark:focus:ring-primary-500',
          'bg-primary-50 dark:bg-primary-800 transition duration-100',
          disabled ? 'pointer-events-none' : '',
          className ?? '',
        )}
      >
        {children}
      </Listbox.Button>
    )
  },
)

Button.displayName = 'Listbox.Button'

export default Button
